import React, { Component } from "react";
import { connect } from "react-redux";
import { EditDeviceDialog } from "../dialogs/EditDeviceDialog";
import { asArray, mapKV } from "../utils/map";
import { editDevice } from "../redux/actions/deviceActions";
import { getDeviceApprovedApps } from "../utils/deviceDialogUtils";

export class EditDevice extends Component {
  state = {
    name: "",
    deviceGroupKey: "",
    nameNotUnique: false,
    saveAvaliable: true,
    notes: ""
  };

  componentDidMount() {
    const { deviceKey, devices } = this.props;
    if(!devices[deviceKey]) return;
    const { name, deviceGroupRef, notes = "" } = devices[deviceKey];
    const deviceGroupKey = deviceGroupRef ? deviceGroupRef.id : "";
    this.setState({ name, deviceGroupKey, notes });
  }

  onNameChange = name => {
    this.setState({ name }, this.checkSaveAvaliable);
  };

  onNotesChange = notes => {
    this.setState({ notes });
  };

  checkSaveAvaliable = () => {
    const { name } = this.state;
    const { devices, deviceKey } = this.props;

    let nameNotUnique = false;
    mapKV(devices, (key, device) => {
      if (key === deviceKey) return;
      if (name === device.name) nameNotUnique = true;
    });
    this.setState({ nameNotUnique });

    let saveAvaliable = true;
    if (name === "" || nameNotUnique) saveAvaliable = false;
    this.setState({ saveAvaliable });
  };

  onDeviceGroupChange = deviceGroupKey => this.setState({ deviceGroupKey });

  onSave = () => {
    const { name, deviceGroupKey, notes } = this.state;
    const { onCancel, editDevice, deviceKey, devices } = this.props;
    const device = devices[deviceKey];
    editDevice({ key: deviceKey, name, deviceGroupKey, device, notes });
    onCancel();
  };

  render() {
    const {
      deviceKey,
      devices,
      deviceGroups,
      installedApps,
      apps,
      contentBundles,
      onCancel,
      loading
    } = this.props;
    const device = devices[deviceKey];
    if(!device) return(<div/>);
    const deviceGroup = device.deviceGroupRef
      ? deviceGroups[device.deviceGroupRef.id]
      : "";
    if(!deviceGroup)return(<div/>); 
    const approvedApps = getDeviceApprovedApps({
      deviceGroup,
      apps,
      contentBundles
    });

    const { name, deviceGroupKey, nameNotUnique, saveAvaliable, notes } = this.state;

    return (
      <EditDeviceDialog
        onClose={onCancel}
        onSave={this.onSave}
        name={name}
        onNameChange={this.onNameChange}
        notes={notes}
        onNotesChange={this.onNotesChange}
        device={device}
        deviceGroupKey={deviceGroupKey}
        onDeviceGroupChange={this.onDeviceGroupChange}
        nameNotUnique={nameNotUnique}
        saveAvaliable={saveAvaliable}
        approvedApps={approvedApps}
        installedApps={installedApps}
        deviceGroups={asArray(deviceGroups)}
        loading={loading}
      />
    );
  }
}

const mapStateToProps = state => {
  return {
    devices: state.data.devices,
    deviceGroups: state.data.deviceGroups,
    installedApps: state.data.installedApps,
    apps: state.data.apps,
    contentBundles: state.data.contentBundles,
    loading: state.ui.loading
  };
};

const mapDispatchToProps = {
  editDevice
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EditDevice);
